import { useState, useContext } from "react";
import { Box, Button, Grid, Stack } from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";

import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle } from "../../Utils/Component";

import TabParty from "./Tab/TabParty";
import TabCandidate from "./Tab/TabCandidate";
import Groups2RoundedIcon from "@mui/icons-material/Groups2Rounded";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";

const getTabClass = (currentTab, tab) => {
  if (tab === currentTab) return "btn-tab-active";
  return "btn-tab";
};

const getTabLocal = () => {
  const tabData = window.localStorage.getItem("tab");
  return tabData || "Party";
};
const setTabLocal = (val) => {
  window.localStorage.setItem("tab", val);
};

export default function PartiesAndCandidates() {
  const { t } = useContext(AuthContext); 
  const [tab, setTab] = useState(getTabLocal());
  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")} 
        classSlash="slash-title"
        routeTo={"/parties-and-candidates"}
        pageTitle={t("page_parties_and_candidates")}
      />

      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              my: 2,
              minWidth: 600,
              borderBottom: 2,
              borderColor: "divider",
            }}
          >
            <Stack direction="row" alignItems="center" sx={{ mb: "-2px" }}>
              <Button
                onClick={() => {
                  setTabLocal("Party");
                  setTab("Party");
                }}
                className={getTabClass("Party", tab)}
                startIcon={<SettingsApplicationsRoundedIcon />}
              >
                {t("thead_party")}
              </Button>

              <Button
                onClick={() => {
                  setTabLocal("Candidate");
                  setTab("Candidate");
                }}
                startIcon={<Groups2RoundedIcon />}
                className={getTabClass("Candidate", tab)}
              >
                {t("thead_candidate")}
              </Button>
            </Stack>
          </Box>
        </Grid>

        {["Candidate"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabCandidate />
          </Grid>
        )}

        {["Party"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabParty />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
